var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boxcontent-item",on:{"click":_vm.select}},[_c('i',{staticClass:"far fa-file"}),_c('p',{staticClass:"boxcontent-item-description"},[_vm._v(_vm._s(_vm.product.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }